module.exports = __webpack_public_path__ + "img/terms_960.763f890d.png";